import { FormControlledInputTextArea } from "../form/FormControlledInputTextArea";
import { requiredValidation } from "../../utils/Validators";
import { View } from "../../atoms/view";
import { Button, ButtonText } from "../../gluestack/button";
import { PermissionCheck } from "app/features/permission/atoms/PermissionCheck";
import { PermissionsEnums } from "app/services/api/types/authorisation/enums/PermissionsEnums";

interface Props {
  control: any;
  onClose: () => void;
  submit: (e?: React.BaseSyntheticEvent) => Promise<void>;
  isSubmitting: boolean;
  voidItem: () => void;
  isVoidLoading: boolean;
  requiredPermission: PermissionsEnums;
  isItemAlreadyVoided: boolean;
}

export default function AddNoteOrVoid({
  control,
  onClose,
  submit,
  isSubmitting,
  voidItem,
  isVoidLoading,
  requiredPermission,
  isItemAlreadyVoided,
}: Props) {
  return (
    <View>
      <FormControlledInputTextArea
        id="note"
        name="note"
        label="Note"
        control={control}
        className="text-gray-500"
        isRequired
        rules={{
          required: requiredValidation("Note field"),
        }}
      />
      <View className="col-span-full">
        <View className="relative flex flex-row justify-end items-center mt-10">
          {!isItemAlreadyVoided && (
            <View className="absolute left-0">
              <PermissionCheck permission={requiredPermission}>
                <Button
                  action="negative"
                  size="sm"
                  variant="outline"
                  onPress={voidItem}
                  disabled={isVoidLoading}
                >
                  <ButtonText>Void</ButtonText>
                </Button>
              </PermissionCheck>
            </View>
          )}
          <View className="flex flex-row gap-4">
            <Button
              action="primary"
              size="sm"
              variant="outline"
              onPress={onClose}
            >
              <ButtonText>Cancel</ButtonText>
            </Button>
            <Button
              action="primary"
              size="sm"
              onPress={submit}
              disabled={isSubmitting}
            >
              <ButtonText className="text-white">Submit</ButtonText>
            </Button>
          </View>
        </View>
      </View>
    </View>
  );
}
